import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './App.css';
import { writings } from './data/writings';


const BlogPost: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const writing = writings.find(w => w.id === id);

  if (!writing) {
    return (
      <div className="min-h-screen bg-[#0D1010] text-[#F0EDE8] font-geist flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-crimson mb-4">Post not found</h1>
          <Link 
            to="/" 
            className="text-[#F0EDE8]/60 hover:text-[#F0EDE8] transition-colors duration-200 underline underline-offset-4"
          >
            ← Back to home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0D1010] text-[#F0EDE8] font-geist">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {/* Back link */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="text-xs text-[#F0EDE8]/40 font-geist-mono hover:text-[#F0EDE8]/60 transition-colors duration-200"
          >
            ← Back to home
          </Link>
        </div>

        {/* Blog post content */}
        <article>
          <header className="mb-6">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-crimson text-[#F0EDE8] mb-4">
              {writing.title}
            </h1>
            <div className="flex items-center gap-2">
              {writing.publishedAt && (
                <span className="text-xs text-[#F0EDE8]/40 font-geist-mono">
                  {new Date(writing.publishedAt).toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' 
                  })}
                </span>
              )}
              {writing.tags && writing.tags.length > 0 && (
                <>
                  <span className="text-xs text-[#F0EDE8]/20">•</span>
                  {writing.tags.map((tag, index) => (
                    <span key={index} className="text-xs text-[#F0EDE8]/40 font-geist-mono">
                      {tag}
                    </span>
                  ))}
                </>
              )}
            </div>
          </header>
          
          {/* Blog post image */}
          {writing.image && (
            <div className="mb-8">
              <img 
                src={writing.image} 
                alt={writing.title}
                className="w-full h-auto rounded-lg"
              />
            </div>
          )}
          
          <div className="prose prose-invert max-w-none">
            <div className="text-[#F0EDE8]/80 leading-relaxed whitespace-pre-line">
              {writing.content}
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
